import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const ColumnWrapper = styled.div`
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    css`
      background-color: ${$backgroundColor};
    `}
  ${({ $textColor }) =>
    $textColor &&
    css`
      color: ${$textColor};
    `}
${({ $linkColor }) =>
    $linkColor &&
    css`
      a {
        color: ${$linkColor};
      }
    `}
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  min-width: 225px;
  flex: 1 1 0px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  padding: ${({ $padding }) => $padding};
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding-inline: 0;
  }
`;

const Column = ({
  backgroundColor,
  children,
  className,
  linkColor,
  style,
  verticalAlignment,
  width,
  textColor,
  padding,
}) => {
  const wrapperProps = {};
  if (className) {
    wrapperProps["className"] = className;
  }
  if (style) {
    wrapperProps["style"] = style;
  }
  if (verticalAlignment) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      justifyContent:
        verticalAlignment === "bottom"
          ? "flex-end"
          : verticalAlignment === "center"
            ? "center"
            : "flex-start",
    };
  }
  if (width) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      flexGrow: width.replace(/%/g, ""),
    };
  }
  return (
    <ColumnWrapper
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      $linkColor={linkColor}
      $padding={padding}
      {...wrapperProps}
    >
      {children}
    </ColumnWrapper>
  );
};

Column.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  verticalAlignment: PropTypes.oneOf(["top", "center", "bottom"]),
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  linkColor: PropTypes.string,
  textColor: PropTypes.string,
  padding: PropTypes.string,
};

Column.defaultProps = {
  children: undefined,
  className: undefined,
  style: undefined,
  verticalAlignment: undefined,
  width: undefined,
};

export default Column;
